// extracted by mini-css-extract-plugin
var _1 = "TaskTableRow-moduleTaskTableRow__hEKeu TableComponent-modulerow__xPAo4";
var _2 = "TaskTableRow-moduledone__Bkxuc";
export { _1 as "TaskTableRow", _2 as "done" }
